<div class="container">
  <main role="main" class="form-signin w-100 m-auto text-center">
    <h1>Permission denied</h1>
    <p>
      You don't have the permissions to see the page you tried to access. If you
      feel this is in error, please contact your district operator.
    </p>
  </main>
</div>
